import styled from "@emotion/styled";

export const FormInner = styled.div({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  position: "relative",
  overflow: "auto",
});
